const AbsentTimeTypeEnum = {
    SL: 'Sick leave',
    UV: 'Unpaid vacation',
    DO: 'Day off',
    GA: 'General absent',
    PV: 'Paid vacation'
  };

export default AbsentTimeTypeEnum;